import React from "react";
import logoMark from "../assets/logo_mark.png";

// Official firm emblem (book, gavel & quill)
const Logo = ({ className = "logo-mark" }) => (
  <img className={className} src={logoMark} alt="Contreras & Asociados PV" />
);

export default Logo;
